import { render, staticRenderFns } from "./AllTransactionCodeTable.vue?vue&type=template&id=4873cd42&scoped=true&"
import script from "./AllTransactionCodeTable.vue?vue&type=script&lang=js&"
export * from "./AllTransactionCodeTable.vue?vue&type=script&lang=js&"
import style0 from "./AllTransactionCodeTable.vue?vue&type=style&index=0&id=4873cd42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4873cd42",
  null
  
)

export default component.exports